<template>
    <div>
        <v-alert :type="alertType" closable v-model="show">
            {{ message }}
        </v-alert>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AlertMessage',
    props: ['message'],
    setup(props) {
        return props;
    },
    data() {
        return {
            show: false,
            alertType: 'error'
        };
    },
    methods: {
        showAlert(type = 'error') {
            this.alertType = type;
            this.show = true;
        }
    }
});
</script>
